/* esm.sh - rxjs@7.8.1/dist/esm/internal/scheduler/async */
import{AsyncAction as c}from"./AsyncAction.mjs";import{AsyncScheduler as o}from"./AsyncScheduler.mjs";var n=new o(c),t=n;export{t as async,n as asyncScheduler};
//# sourceMappingURL=async.mjs.map